import { render, staticRenderFns } from "./PageFormTest.vue?vue&type=template&id=a7ddf40a&scoped=true&"
import script from "./PageFormTest.vue?vue&type=script&lang=ts&"
export * from "./PageFormTest.vue?vue&type=script&lang=ts&"
import style0 from "./PageFormTest.vue?vue&type=style&index=0&id=a7ddf40a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7ddf40a",
  null
  
)

export default component.exports